export const iconFontAwesomeHumanitarianPersonBurst = (
	<i className="fa-solid fa-person-burst"></i>
);
